import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { style: {"font-weight":"bold","margin-bottom":"4px"} }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "option-images" }
const _hoisted_5 = { class: "no-mb" }
const _hoisted_6 = { style: {"font-size":"12px","font-weight":"400"} }
const _hoisted_7 = {
  key: 1,
  class: "options-mobile"
}
const _hoisted_8 = { class: "option-images" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["src"]

import SubtotalWidget from '@/components/SubtotalWidget.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, ref } from 'vue'
import { generalStore } from '@/stores/general'
import { subtotalStore } from '@/stores/subtotal'
import { headerStore } from '@/stores/header'
import { authStore } from '@/stores/auth'
import { completionThreeStore } from '@/stores/completionThree'
import { Carousel, Slide, Navigation } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
import { WarningTwoTone } from '@ant-design/icons-vue'
import ListOption from '@/components/ListOption.vue'
import SubtotalMobileWidget from '@/components/SubtotalMobileWidget.vue'
import UnityWidget from '@/components/dashboard/UnityWidget.vue'
import { ls } from '@/ls'


export default /*#__PURE__*/_defineComponent({
  __name: 'Completion3',
  setup(__props) {

const router = useRouter()

const building = computed(() => ls.get('building'))

const columns = [
  {
    title: 'Optie',
    key: 'external_ref',
    width: 80
  },
  {
    title: 'Omschrijving',
    key: 'option'
  },
  {
    title: 'Prijs incl. BTW',
    key: 'price',
    width: 130
  },
  {
    title: '',
    key: 'actions',
    width: 176
  }
]

const showOptionModal = ref(false)
const currentOption = ref<{ id:number, name_sales:string, allImages:string[] }|null>(null)
const slideIndex = ref(0)

const isInternalTestAccount = computed(() => authStore().isInternalTestAccount)
const showOptions = computed(() => !['loading', 'test'].includes(completionThreeStore().phaseState) || isInternalTestAccount.value)

onMounted(() => {
  completionThreeStore().getPhaseState()
  completionThreeStore().getOptions()
})

function toggleOptionModal (option:{ id:number, name_sales:string, allImages:string[] }, startAtIndex = 0) : void {
  showOptionModal.value = !showOptionModal.value
  currentOption.value = showOptionModal.value ? option : null
  slideIndex.value = startAtIndex
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,4] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Afbouw 3 opties",
            loading: _unref(completionThreeStore)().loading
          }, {
            extra: _withCtx(() => [
              (_unref(building)?.unity_enabled && _unref(building)?.model_available)
                ? (_openBlock(), _createBlock(UnityWidget, {
                    key: 0,
                    style: { marginRight: '8px' }
                  }))
                : _createCommentVNode("", true),
              (_unref(generalStore)().desktop)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Terug naar dashboard")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              (['loading', 'test', 'demo', 'closed'].includes(_unref(completionThreeStore)().phaseState) || _unref(authStore)().isDemoCustomer)
                ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          (_unref(completionThreeStore)().phaseState === 'test' && !_unref(isInternalTestAccount))
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 0,
                                type: "info",
                                message: "Er zijn voor deze fase (nog) geen opties beschikbaar.",
                                description: "Deze opties worden op een later moment zichtbaar.",
                                "show-icon": ""
                              }))
                            : _createCommentVNode("", true),
                          (_unref(completionThreeStore)().phaseState === 'demo' || _unref(authStore)().isDemoCustomer)
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 1,
                                type: "info",
                                message: "U bevindt zich in de demo omgeving.",
                                description: "U kunt (nog) geen definitieve bestelling plaatsen voor deze fase.",
                                "show-icon": ""
                              }))
                            : _createCommentVNode("", true),
                          (_unref(completionThreeStore)().phaseState === 'closed' && _unref(headerStore)().ordersReceived.carcass && !_unref(authStore)().isDemoCustomer)
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 2,
                                type: "success",
                                message: "Bestelling succesvol ontvangen.",
                                "show-icon": ""
                              }, {
                                description: _withCtx(() => [
                                  _createTextVNode(" Wij hebben uw bestelling voor de afbouw opties succesvol ontvangen."),
                                  _hoisted_1,
                                  _createTextVNode(" Het is niet meer mogelijk om uw afbouw opties te wijzigen. Dit is om de voortgang van het bouwproces te continueren. ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_unref(completionThreeStore)().phaseState === 'closed' && !_unref(headerStore)().ordersReceived.carcass && !_unref(authStore)().isDemoCustomer)
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 3,
                                type: "error",
                                message: "Deze fase is gesloten maar wij hebben geen bestelling ontvangen!",
                                "show-icon": ""
                              }, {
                                description: _withCtx(() => [
                                  _createTextVNode(" Neem zo spoedig mogelijk contact op met Hofzicht Makelaars via telefoonnummer 0252 - 530119. ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(showOptions))
                ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          (_unref(completionThreeStore)().options && _unref(generalStore)().desktop)
                            ? (_openBlock(), _createBlock(_component_a_table, {
                                key: 0,
                                columns: columns,
                                "data-source": _unref(completionThreeStore)().options,
                                pagination: false
                              }, {
                                bodyCell: _withCtx(({ column, record }) => [
                                  (column.key === 'external_ref')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(record.external_ref), 1)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (column.key === 'option')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("p", _hoisted_2, [
                                          _createTextVNode(_toDisplayString(record.name_sales) + " ", 1),
                                          (record.excluded_from_warranty)
                                            ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                                                title: _withCtx(() => [
                                                  _createTextVNode("Deze optie is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(WarningTwoTone), {
                                                    "two-tone-color": "#f38929",
                                                    style: {"margin-left":"4px"}
                                                  })
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", {
                                          innerHTML: record.text_sales
                                        }, null, 8, _hoisted_3),
                                        _createElementVNode("div", _hoisted_4, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.allImages, (image, index) => {
                                            return (_openBlock(), _createBlock(_component_a_avatar, {
                                              src: image.url,
                                              size: 90,
                                              shape: "square",
                                              style: {"cursor":"zoom-in","margin":"0 12px 12px 0","border":"2px solid #f0f2f5"},
                                              key: index,
                                              onClick: ($event: any) => (toggleOptionModal(record, index))
                                            }, null, 8, ["src", "onClick"]))
                                          }), 128))
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (column.key === 'price')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createElementVNode("p", _hoisted_5, "€ " + _toDisplayString(record.price.toLocaleString('nl-NL')), 1),
                                        _createElementVNode("p", _hoisted_6, "incl. " + _toDisplayString(record.vat_rate) + "% BTW", 1)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (column.key === 'actions')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        (!record.selected && !_unref(completionThreeStore)().isDisabled[record.id])
                                          ? (_openBlock(), _createBlock(_component_a_button, {
                                              key: 0,
                                              loading: _unref(completionThreeStore)().savingId === record.id,
                                              disabled: _unref(authStore)().restricted() || _unref(completionThreeStore)().savingId !== 0 || _unref(completionThreeStore)().removingId !== 0 || _unref(completionThreeStore)().phaseIsClosed,
                                              onClick: ($event: any) => (_unref(completionThreeStore)().selectOption(record))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_unref(completionThreeStore)().phaseIsClosed ? 'Niet gekozen' : 'Kies'), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["loading", "disabled", "onClick"]))
                                          : (!record.selected && _unref(completionThreeStore)().isDisabled[record.id])
                                            ? (_openBlock(), _createBlock(_component_a_button, {
                                                key: 1,
                                                disabled: true
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(completionThreeStore)().phaseIsClosed ? 'Niet gekozen' : 'Niet beschikbaar'), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : (record.selected)
                                              ? (_openBlock(), _createBlock(_component_a_button, {
                                                  key: 2,
                                                  type: "primary",
                                                  class: "option-btn",
                                                  loading: _unref(completionThreeStore)().removingId === record.id,
                                                  disabled: _unref(authStore)().restricted() || _unref(completionThreeStore)().savingId !== 0 || _unref(completionThreeStore)().removingId !== 0 || _unref(completionThreeStore)().phaseIsClosed,
                                                  onClick: ($event: any) => (_unref(completionThreeStore)().unselectOption(record))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Gekozen")
                                                  ]),
                                                  _: 2
                                                }, 1032, ["loading", "disabled", "onClick"]))
                                              : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["data-source"]))
                            : (_unref(completionThreeStore)().options && !_unref(generalStore)().desktop)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(completionThreeStore)().options, (o) => {
                                    return (_openBlock(), _createBlock(ListOption, {
                                      option: o,
                                      key: o.id
                                    }, {
                                      images: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_8, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(o.allImages, (image, index) => {
                                            return (_openBlock(), _createBlock(_component_a_avatar, {
                                              src: image.url,
                                              size: 90,
                                              shape: "square",
                                              style: {"cursor":"zoom-in","margin":"0 12px 12px 0","border":"2px solid #f0f2f5"},
                                              key: index,
                                              onClick: ($event: any) => (toggleOptionModal(o, index))
                                            }, null, 8, ["src", "onClick"]))
                                          }), 128))
                                        ])
                                      ]),
                                      buttons: _withCtx(() => [
                                        (!o.selected && !_unref(completionThreeStore)().isDisabled[o.id])
                                          ? (_openBlock(), _createBlock(_component_a_button, {
                                              key: 0,
                                              loading: _unref(completionThreeStore)().savingId === o.id,
                                              disabled: _unref(authStore)().restricted() || _unref(completionThreeStore)().savingId !== 0 || _unref(completionThreeStore)().removingId !== 0 || _unref(completionThreeStore)().phaseIsClosed,
                                              onClick: ($event: any) => (_unref(completionThreeStore)().selectOption(o))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_unref(completionThreeStore)().phaseIsClosed ? 'Niet gekozen' : 'Kies'), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["loading", "disabled", "onClick"]))
                                          : (!o.selected && _unref(completionThreeStore)().isDisabled[o.id])
                                            ? (_openBlock(), _createBlock(_component_a_button, {
                                                key: 1,
                                                disabled: true
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(completionThreeStore)().phaseIsClosed ? 'Niet gekozen' : 'Niet beschikbaar'), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : (o.selected)
                                              ? (_openBlock(), _createBlock(_component_a_button, {
                                                  key: 2,
                                                  type: "primary",
                                                  class: "option-btn",
                                                  loading: _unref(completionThreeStore)().removingId === o.id,
                                                  disabled: _unref(authStore)().restricted() || _unref(completionThreeStore)().savingId !== 0 || _unref(completionThreeStore)().removingId !== 0 || _unref(completionThreeStore)().phaseIsClosed,
                                                  onClick: ($event: any) => (_unref(completionThreeStore)().unselectOption(o))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Gekozen")
                                                  ]),
                                                  _: 2
                                                }, 1032, ["loading", "disabled", "onClick"]))
                                              : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["option"]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createBlock(_component_a_alert, {
                                  key: 2,
                                  type: "info",
                                  message: "Er zijn voor deze fase (nog) geen opties beschikbaar.",
                                  description: "Deze opties worden op een later moment zichtbaar.",
                                  "show-icon": ""
                                }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 24,
                        style: _normalizeStyle(_unref(generalStore)().desktop ? { padding: '8px', textAlign: 'right' } : {})
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", {
                            style: _normalizeStyle(_unref(generalStore)().desktop ? { marginRight: 32 } : {})
                          }, "Totaal meer- en minderwerk afbouw 3:", 4),
                          _createTextVNode(),
                          (!_unref(generalStore)().desktop)
                            ? (_openBlock(), _createElementBlock("br", _hoisted_9))
                            : _createCommentVNode("", true),
                          _createTextVNode(" € " + _toDisplayString(_unref(subtotalStore)().subtotals.completion3), 1)
                        ]),
                        _: 1
                      }, 8, ["style"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_row, { class: "no-mb" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        style: _normalizeStyle(_unref(generalStore)().desktop ? { float: 'right' } : { width: '100%' }),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'Summary' })))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Naar samenvatting")
                        ]),
                        _: 1
                      }, 8, ["style"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }),
      (_unref(generalStore)().desktop)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            span: 6
          }, {
            default: _withCtx(() => [
              _createVNode(SubtotalWidget)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_unref(generalStore)().desktop)
        ? (_openBlock(), _createBlock(SubtotalMobileWidget, { key: 1 }))
        : _createCommentVNode("", true),
      (currentOption.value)
        ? (_openBlock(), _createBlock(_component_a_modal, {
            key: 2,
            title: currentOption.value.title,
            width: 600,
            "body-style": { padding: 0 },
            visible: showOptionModal.value,
            footer: false,
            onCancel: toggleOptionModal
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Carousel), {
                "wrap-around": true,
                "model-value": slideIndex.value
              }, {
                addons: _withCtx(() => [
                  _createVNode(_unref(Navigation))
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentOption.value.allImages, (image) => {
                    return (_openBlock(), _createBlock(_unref(Slide), { key: image }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: image.url,
                          style: {"width":"100%"}
                        }, null, 8, _hoisted_10)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["model-value"])
            ]),
            _: 1
          }, 8, ["title", "visible"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})